<template>
	<div class="allbg">
		<!-- 头 -->
		<tyheader pageind="1"/>
		<section class="n_banner" :style=" 'background:url('+bannerurl+') center no-repeat;'"></section>
		<section class="n_title n_title01">
			<div class="w1400 pagetit">
				<div class="left">
					<div class="n_nav">
						<a v-for="(item, index) in newsmenu" :key="index" :class="{on:newstabind == index}" @click="otherrout(item.code,index)" style="cursor: pointer;"><strong>{{item.title}}</strong></a>
						<!-- <a href="#"><strong>企业架构</strong></a>
						<a href="#"><strong>领导风采</strong></a>
						<a href="#"><strong>发展历程</strong></a>
						<a href="#"><strong>文化理念</strong></a>
						<a href="#"><strong>企业荣誉</strong></a> -->
					</div>
				</div>
				<div class="right ">
					<div class="position"><a href="#">首页</a> <i>-</i> <a href="/about?type=&index=0">走进双沟</a> <i>-</i> <em>{{newstabname}}</em> </div>
				</div>
			</div>
		</section>
		<section class="n_container">
			<div v-if="oldcode == 1631179008439" class="w1400">
				<div class="rylist">
					<div v-for="(item,index) in newslist" v-if="index<2" class="rymod news-container">
						<h2 class="title" style="font-size:20px !important;">{{item.title}}</h2>
						<p class="intro" style="height: 96px !important;margin-top: 14px;margin-bottom: 14px;">{{item.intro}}</p>
						<img class="rymodimg" :src="imgurl+item.showImage" >
						<a :href="'/aboutdet?code='+item.code+'&ind=5'"><div class="knowmore">了解更多</div></a>
					</div>
					<!-- <div class="rymod news-container">
						<h2 class="title" style="font-size:20px !important;">双沟酒业荣获双沟酒业荣获双沟酒业荣获双沟酒业荣获双沟酒业荣获</h2>
						<p class="intro">双沟酒业荣获双沟酒业荣获双沟酒业荣获双沟酒业荣获双沟酒业荣获双沟酒业荣获双沟酒业荣获双沟酒业荣获双沟酒业荣获双沟酒业荣获双沟酒业荣获双沟酒业荣获双沟酒业荣获双沟酒业荣获双沟酒业荣获双沟酒业荣获双沟酒业荣获双沟酒业荣获双沟酒业荣获双沟酒业荣获</p>
						<img src="../assets/images/ryimg2.png" >
					</div> -->
				</div>
				<div class="" style="margin-top: 40px;">
					<h2 class="rytit">孙中山先生手迹 “ <p style="font-weight: 600;display: inline-block;">双沟醴泉</p> ” </h2>
					<img class="ryimg" src="../assets/images/ryimg.png" >
				</div>
				<div class="ryswiper">
					<h2 class="ryswipertit">荣誉历程(1910-至今)</h2>
					<swiper class="" :options="swiperOption1" ref="mySwiper1" style="margin-top: 40px;position: relative;">
						<swiper-slide v-for="(item, index) in rylc.banner" :key="index">
							<img style="width: 100% !important;" :src="imgurl+item" >
						</swiper-slide>
						<div class="swiper-button-prev topbanner1" slot="button-prev"></div>
						<div class="swiper-button-next topbanner2" slot="button-next"></div>
					</swiper>
					<div class="ryword">
						<div class="" v-html="rylc.content"></div>
						
					</div>
				</div>
				
				
				
			</div>
			<div v-else class="w1400" v-html="newslist.content"></div>
			<div class="backpage" @click="backpage()">返回</div>
		</section>
		<tyfooter></tyfooter>
	</div>
</template>

<script>
	// 引入插件
	import { swiper, swiperSlide } from "vue-awesome-swiper";
	import "swiper/dist/css/swiper.css";
	import tyheader from './header.vue'
	import tyfooter from './footer.vue'
	export default {
	  name: 'product',
		components: {
			swiper,
			swiperSlide,
			tyheader,
			tyfooter
		},
		metaInfo () {
			return {
				title: this.seot,
				meta: [   // set meta
					{                
						name: 'keyWords',
						content: this.seok
					},
					{
						name: 'description',
						content: this.seod
					}
				]
			}
		},
		data(){
			return{
				seot:this.COMMON.seotit,
				seod:this.COMMON.seodec,
				seok:this.COMMON.seokey,
				isshow:this.COMMON.isshow(),
				imgurl:this.COMMON.imgurl,
				bannerurl:'',
				newstabind:0,
				newsmenu:'',
				newstabname:'',
				newslist:'',
				oldcode:'',
				rylist:[1,2,3],
				swiperOption1: {
					loop: true,
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev',
					},
				},
				rylc:''
			}
		},
		computed:{
			swiper1() {
			  return this.$refs.mySwiper1.swiper;
			},
		},
		mounted() {
			let that = this
			let artcode = this.$route.query.type
			let artind = this.$route.query.ind
			let menuindex = this.$route.query.index
			that.oldcode = this.$route.query.type
			that.newstabind = this.$route.query.ind
			that.menuindex = this.$route.query.index
			that.$axios.post('/w/menu').then(function (response) {
				that.bannerurl = that.imgurl + response.data[0].banner
			}).catch(function (error) {
					console.log(error);
			});
			that.getaboutlist()
			
			that.$axios.post('/w/pageseo?address='+'/about').then(function (response) {
				if(JSON.stringify(response.data) != "{}"){
					that.seot = response.data.seoTitle
					that.seok = response.data.seoKey
					that.seod = response.data.seoDes
				}
			}).catch(function (error) {
					console.log(error);
			});
			
			this.$axios.post('/w/art?menuCode=&&amount=&&page=&&code='+'1632291432692').then(function (response) {
				response.data.list[0].banner = response.data.list[0].banner.split(',')
				that.rylc = response.data.list[0]
			})
			.catch(function (error) {
				console.log(error);
			});
			
		},
		methods:{
			backpage(){
				this.$router.go(-1)
			},
			getaboutlist(){
				let that = this
				this.$axios.post('/w/menu?code=1631172414055').then(function (response) {
					if(that.oldcode && that.newstabind){
						that.getnewslist(that.oldcode,that.newstabind)
					}else{
						that.getnewslist(response.data[0].code,0)
					}
					that.newsmenu = response.data
					
				})
				.catch(function (error) {
					console.log(error);
				});
			},
			getnewslist(num,ind){
				let that = this
				this.$axios.post('/w/art?code=&&amount=&&page=&&menuCode='+num).then(function (response) {
					if(that.oldcode == 1631179008439){
						that.newslist = response.data.list
					}else{
						that.newslist = response.data.list[0]
					}
					// 
					that.newstabind = ind
					that.newstabname = that.newsmenu[ind].title
				})
				.catch(function (error) {
					console.log(error);
				});
			},
			otherrout(num,ind){
				this.$router.push({path:'/about',query: {type:num,ind:ind}})
			}
		},
		watch:{
			$route(){
				this.oldcode = this.$route.query.type
				this.newstabind = this.$route.query.ind
				this.getaboutlist()
			},
		}
	}
</script>

<style scoped="scoped">
	article, aside, footer, header, nav, section {display: block;}
	img {
	    border-style: none;
	    max-width: 100%;
	    vertical-align: top;
	    width: auto!important;
	    height: auto!important;
	}
	.n_banner {height: 70vh;background-size: cover !important;}
	.n_title {height: 74px;border-bottom: #e7e7ea 1px solid;padding: 0;position: relative;background: #fff;}
	.pagetit{display: flex;justify-content: space-between;}
	.n_nav {position: relative;}
	.n_nav a {display: inline-block;height: 74px;font-size: 18px;float: left;line-height: 75px;color: #333333;text-align: center;box-sizing: border-box;position: relative;-moz-border-radius: 3px;-webkit-border-radius: 3px;border-radius: 3px;margin-right: 3.125rem;}
	.n_nav a:before {content: "";width: 0;height: 3px;position: absolute;bottom: 0;left: 0;background: #119e7f;transition: 0.6s ease-in-out;}
	.n_nav .on:before, .n_nav a:hover:before {width: 100%;}
	.position {line-height: 74px;color: #7b7b7d;padding-left: 22px;font-size: 14px;background: url(../assets/images/home_icon.png) left 30px no-repeat;}
	.position i {
		margin: 0px 5px;
		font-style: normal;
	}
	.position span, .position a, .position i {
		font-size: 14px;
		color: #7b7b7d;
		-moz-transition: all 0.36s ease-in-out;
		-webkit-transition: all 0.36s ease-in-out;
		-o-transition: all 0.36s ease-in-out;
		-ms-transition: all 0.36s ease-in-out;
		transition: all 0.36s ease-in-out;
	}
	.position em {
		font-size: 14px;
		color: #acacac;
		font-style: normal;
	}
	.n_container {
		background: url(../assets/images/n_container_bg.jpg) center bottom no-repeat #fff;
		background-size: 100% auto;
		width: 100%;
		padding: 30px 0px;
	}
	.rytit{font-size: 20px;margin-top: -20px;text-align: left;font-weight: 500;margin-bottom: 40px;}
	.ryimg{width: 100% !important;}
	.rylist{
		width: 100%;
		display: flex;
		justify-content: space-between;
		/* text-align: left; */
		flex-wrap: wrap;
	}
	.rymod{
		width: 100%;
	}
	.rymodimg{
		width: calc(100% - 140px) !important;
		margin: 0 auto;
		padding: 0 20px;
	}
	.knowmore{
		width: 200px;
		padding: 8px 0px;
		border: 1px solid #333333;
		margin-left: 20px;
		margin-top: 20px;
		font-size: 14px;
	}
	.ryswiper{
		text-align: left;
		margin-top: 60px;
	}
	.ryswipertit{
		letter-spacing: 2px;
		font-weight: 500;
		font-size: 26px;
	}
	.ryword{
		padding: 30px 80px;
		width: calc(100% - 160px);
		background-color: rgb(246,247,249);
		margin-top: 40px;
		margin-bottom: 50px;
		max-height: 140px;
		overflow-y: scroll;
	}
	::-webkit-scrollbar {
	   width: 2px;
	   height: 2px;
	 }
	 
	.ryword::-webkit-scrollbar-track-piece {
	   background-color: #fff;
	   -webkit-border-radius: 6px;
	 }
	 
	 .ryword::-webkit-scrollbar-thumb:vertical {
	   height: 5px;
	   background-color: #666;
	   -webkit-border-radius: 6px;
	 }
	 
	 .ryword::-webkit-scrollbar-thumb:horizontal {
	   width: 5px;
	   background-color: #666;
	   -webkit-border-radius: 6px;
	 }
	 
		.topbanner1,.topbanner2{
		 width: 3rem;
		 height: 3rem;
		 background-color: rgb(246,247,249);
		 border-radius: 50%;
		 background-size: 70%;
		 position: absolute;
		 box-shadow: 0px 0px 10px rgb(0,0,0,0.5);
		}
		.topbanner1{
			background-position: 25% 38%;
		}
	 .topbanner2{
	 		background-position: 56% 38%;
	 }
	 .swiper-button-prev, .swiper-container-rtl .swiper-button-next{
		 background-image: url(../assets/images/zuojt.png);
	 }
	 .swiper-button-next, .swiper-container-rtl .swiper-button-prev {
	     background-image: url(../assets/images/youjt.png);
	 }
	 
	 @media screen and (max-width: 767px) {
	 	.n_title{height: 50px;}
	 	.n_nav a{height: 50px;line-height: 50px;}
	 	.position{line-height: 50px;background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAMCAYAAAC5tzfZAAAAuElEQVQokZXRoU4DQRQF0LOT0RtCkKTB9Qdo+QY0hg+ApAKaFQj6G8XVUlldW40kCMjK6josEMxsMkyWQK95L3PnJJNM1TSNnsxwh0XafyT2gDlu036PI1znF0IBVhnocoV1H6rxhIu+t+I89YcdOsMLxr+ALmM8YxSwxOAP0OUYjwGX+PgngknAK772QG3EAaqieECLIW6Kro4JlGia7SWqQgLlJ58UM0+M2GGD06z4zOZ7dv6G7TfQZhwU9L0NbQAAAABJRU5ErkJggg==) left 19px no-repeat;}
	   .left{width: 7rem;
	   height: 50px;
	   overflow: hidden;}
	 	.left{background: url(../assets/images/downarr.png) right 15px no-repeat ;background-size: 20px;}
	 	.left:hover{height:auto;background: url(../assets/images/downarr.png) right 15px no-repeat #ffffff;background-size: 20px;box-shadow: 0px 0px 10px rgb(0,0,0,0.5);}
	 }
	 .news-container .title{margin-bottom: 0px;}
	 .news-container{position: relative;}
	 .news-container a{position: absolute;right: 0px;bottom: 20px;}
</style>
